import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
//import { createTransferFunc } from './GetSaveTransfersFunc';
import { withSnackbarMessage } from '../../context/SnackbarMessage';
import { compose } from '../../reactApolloCompat';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent, Icon } from '@mui/material';
import Grid from '../../component/form/Grid';
import gql from 'graphql-tag';
import FuneralAutoComplete from '../../component/form/FuneralAutoComplete';
import cx from 'classnames';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import DialogTitle from '@mui/material/DialogTitle';
import Hidden from '../../component/Hidden';
import { SaveIcon, TransfersIcon } from '../../component/IconIndex';
import { flattenConnection } from '../../util/graphql';
import NewTransferForm from './NewTransferForm';
import DataFormView from '../../component/form/v2/DataFormView';
import { buildTabDataFragment } from '../../util/functions';
import CloseIcon from '../workQueue2/extras/CloseIcon';
import { OutlineButton, SaveButton } from '../../component/form/PrimaryButton';
import { joinDefined } from '../../util/strings';

class NewTransferModal extends Component {
    state = { funeralID: null, modalTitle: 'Add New' };
    nodeRefs = new Map();

    static getDerivedStateFromProps(newProps, oldState) {
        if (!newProps.open) return { funeralID: null };
        if (!!newProps.funeralID && newProps.funeralID !== oldState.funeralID) return { funeralID: newProps.funeralID };
        return null;
    }

    getNodeRef = diagId => {
        if (!this.nodeRefs.has(diagId)) {
            this.nodeRefs.set(diagId, React.createRef());
        }
        return this.nodeRefs.get(diagId);
    };
    PaperComponent = (props, diagId) => {
        const nodeRef = this.getNodeRef(diagId);
        return (
            <Draggable
                key={diagId}
                nodeRef={nodeRef}
                handle={`#${diagId}`}
                cancel={'[class*="MuiDialogContent-root"]'}
                bounds="body"
            >
                <Paper ref={nodeRef} {...props} />
            </Draggable>
        );
    };
    handleClose = (evt, reason, diagId) => {
        const { onClose } = this.props;
        const { funeralID } = this.state;
        if (!funeralID || (reason !== 'backdropClick' && reason !== 'escapeKeyDown')) {
            this.nodeRefs.delete(diagId);
            onClose && onClose(evt);
        }
    };

    render() {
        const { classes, open, funeralID } = this.props;
        const { modalTitle, funeralID: funKey } = this.state;
        const diagId = `ViewTransferModal-${funeralID ? funeralID : 'X'}`;
        return (
            <Dialog
                disableEscapeKeyDown={!!funKey}
                className={cx('draggable-root')}
                classes={{ paper: cx(classes.root, 'dialog-modal modal') }}
                open={open}
                onClose={(evt, reason) => this.handleClose(evt, reason, diagId)}
                PaperComponent={props => this.PaperComponent(props, diagId)}
            >
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        overflow: 'hidden',
                        pointerEvents: 'none'
                    }}
                >
                    <TransfersIcon
                        style={{
                            opacity: 0.025,
                            width: 300,
                            height: 300,
                            position: 'absolute',
                            right: -24,
                            top: 124,
                            transform: 'rotate(20deg)',
                            zIndex: 0
                        }}
                    />
                </div>
                <DialogTitle className={classes.diagHeader}>
                    <div className={classes.dragMe} id={diagId}>
                        <Icon>drag_indicator</Icon>
                    </div>
                    <div>
                        <Hidden smDown>
                            <TransfersIcon className={classes.diagHeaderIcon} />
                            <div className={classes.diagHeaderTitle}>{modalTitle}</div>
                            <div className={classes.diagHeaderSubtitle}>Transfer</div>
                        </Hidden>
                        <Hidden smUp>
                            <div className={classes.diagHeaderTitle}>{modalTitle} Transfer</div>
                        </Hidden>
                    </div>
                </DialogTitle>

                {!funKey ? this.renderLookupForm() : this.renderEditForm()}
            </Dialog>
        );
    }

    renderLookupForm = () => {
        const { classes, onClose } = this.props;
        const variables = {
            sortBy: [{ field: 'DateOfService', direction: 'DESC' }],
            filters: [{ field: 'Cancelled', value: '0' }],
            filterBy: []
        };
        return (
            <>
                <DialogContent className={classes.diagBody}>
                    <Grid container>
                        <Grid bucket>
                            <Grid xs={12}>
                                <FuneralAutoComplete
                                    extraVariables={variables}
                                    readAllQuery={TransfersLookupQuery}
                                    selectProps={{ multiple: false }}
                                    placeholder="Search for a deceased record..."
                                    onSelect={(_, funeral) => this.setState({ funeralID: funeral.ID })}
                                    label="Deceased Name"
                                />
                                <p style={{ fontSize: ' 0.875rem', fontStyle: 'italic', color: 'rgb(153, 153, 153)' }}>
                                    Please select whom this transfer is for.
                                </p>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className={cx(classes.diagActions, 'modal-footer', 'paper')}>
                    <OutlineButton onClick={onClose}>
                        <CloseIcon />
                        <Hidden smDown>Close</Hidden>
                    </OutlineButton>
                    <SaveButton disabled>
                        <SaveIcon />
                        <Hidden smDown>Save</Hidden>
                    </SaveButton>
                </DialogActions>
            </>
        );
    };

    renderEditForm() {
        const { onClose, classes } = this.props;
        const { funeralID } = this.state;
        const fakeContext = { forceUpdate: () => null };
        return (
            <DataFormView
                tabs={Tabs}
                createNew={false}
                createNewFunc={null}
                objectType="Funeral"
                itemId={funeralID}
                context={fakeContext}
                additionalActions={[
                    {
                        label: (
                            <>
                                <CloseIcon />
                                <Hidden smDown>Close</Hidden>
                            </>
                        ),
                        component: OutlineButton,
                        onClick: onClose,
                        skipSave: true
                    }
                ]}
                classes={{
                    footerButtonsContainer: cx(classes.saveButtonContainer, 'modal-footer paper')
                }}
                onUpdated={result => onClose(null, result?.ID > 0)}
                onLoad={row => {
                    const { modalTitle } = this.state;
                    if (!row.Transfers.length || !row.Transfers.find(obj => !obj.TransferActioned)) {
                        if ('Add New' !== modalTitle) this.setState({ modalTitle: 'Add New' });
                    } else if ('Add New' === modalTitle) this.setState({ modalTitle: 'Update' });
                }}
            />
        );
    }
}

const TransfersLookupQuery = gql`
    fragment TransfersLookup on Funeral {
        ID
        LegacyKey
        FirstName
        MiddleName
        Surname
        DateOfDeath1
    }
    query ReadTransfersActive($limit: Int, $offset: Int, $sortBy: [SortField], $contains: String, $key: String) {
        readFunerals(transfer: false, limit: $limit, offset: $offset, sortBy: $sortBy, contains: $contains, key: $key) {
            edges {
                node {
                    ...TransfersLookup
                }
            }
            pageInfo {
                totalCount
            }
        }
    }
`;

const TransferActionsFragment = buildTabDataFragment(
    [
        gql`
            fragment TransfersRecord on Funeral {
                ID
                LegacyKey
                FirstName
                MiddleName
                Surname
                DateOfDeath1
                TransferActioned
                UsePlaceOfDeathAddress
                TransferFromType
                PlaceOfDeathType
                IsBariatric
                IsInfectious
                IsDecomposed
                MortuaryLocation {
                    ID
                    Name
                    FullAddress
                }
                TransferFrom {
                    ID
                    Name
                    Phone
                    FullAddress
                }
                TransferFromResidentialAddress {
                    ID
                    LocationFlattened
                }
                PlaceOfDeath {
                    ID
                    Name
                    Phone
                    FullAddress
                }
                PlaceOfDeathResidentialAddress {
                    ID
                    LocationFlattened
                }
                Transfers {
                    ID
                    Created
                    LastEdited
                    Notes
                    Bariatric
                    InfectionRisk
                    Decomposed
                    CompletedAt
                    CompletedAtTime
                    TransferActioned
                    DepartureText
                    DestinationText
                    Destination {
                        ID
                        Name
                        Phone
                        FullAddress
                    }
                    CreatedBy {
                        ID
                        Surname
                        FirstName
                    }
                    CompletedBy {
                        ID
                        Surname
                        FirstName
                    }
                    AssignedStaff {
                        edges {
                            node {
                                ID
                                Surname
                                FirstName
                            }
                        }
                    }
                }
            }
        `
    ],
    'Funeral'
);
const Tabs = [
    {
        id: 'TransfersActions',
        label: 'Transfer Actions',
        component: NewTransferForm,
        fragment: TransferActionsFragment,
        onLoad: data => {
            if (Array.isArray(data.Transfers) && data.Transfers.length > 0) {
                flattenConnection(data, 'Transfers');
                data.Transfers.forEach(obj => flattenConnection(obj, 'AssignedStaff'));
            } else {
                const initialTransferActioned = data.TransferActioned;
                // create initial transfer from initial call
                let initialLocation = '';
                if (data.UsePlaceOfDeathAddress) {
                    initialLocation =
                        'AddressBook' === data.PlaceOfDeathType && data.PlaceOfDeath?.ID > 0
                            ? joinDefined([data.PlaceOfDeath.Name, data.PlaceOfDeath.FullAddress], '\n')
                            : data.PlaceOfDeathResidentialAddress?.LocationFlattened;
                } else {
                    initialLocation =
                        'AddressBook' === data.TransferFromType && data.TransferFrom?.ID > 0
                            ? joinDefined([data.TransferFrom.Name, data.TransferFrom.FullAddress], '\n')
                            : data.TransferFromResidentialAddress?.LocationFlattened;
                }
                let initialDestination = '';
                if (data.MortuaryLocation?.ID > 0) {
                    initialDestination = joinDefined(
                        [data.MortuaryLocation.Name, data.MortuaryLocation.FullAddress],
                        '\n'
                    );
                }
                data.Transfers = [
                    {
                        AssignedStaff: [],
                        DepartureText: initialLocation,
                        DestinationText: initialDestination,
                        TransferActioned: !!initialTransferActioned,
                        Bariatric: data.IsBariatric || false,
                        InfectionRisk: data.IsInfectious || false,
                        Decomposed: data.IsDecomposed || false
                    }
                ];
            }
            const lastTransfer = data.Transfers[data.Transfers.length - 1];
            if (lastTransfer.TransferActioned) {
                // already done previous transfer, create new transfer
                data.Transfers.push({
                    AssignedStaff: [],
                    DepartureText: lastTransfer.DestinationText || null,
                    DestinationText: null,
                    TransferActioned: false,
                    Bariatric: lastTransfer.Bariatric || false,
                    InfectionRisk: lastTransfer.InfectionRisk || false,
                    Decomposed: lastTransfer.Decomposed || false
                });
            }
        },
        formatSaveData: (saveData, state, original) => {
            saveData.Transfers = state.Transfers.map(was => {
                const obj = { ...was };
                obj.AssignedStaff = was.AssignedStaff.map(me => ({ ID: me.ID }));
                obj.DestinationID = was.Destination?.ID;
                delete obj.Destination;
                obj.FuneralID = saveData.ID;
                return obj;
            });
        }
    }
];

const styles = ({ breakpoints, spacing, palette, funeralHome }) => ({
    root: {
        maxWidth: 800,
        width: '100%',
        overflow: 'hidden',
        [breakpoints.down('sm')]: {
            margin: spacing(1)
        },
        '& > div:last-child': {
            display: 'flex',
            overflow: 'hidden',
            '& > form': {
                display: 'flex',
                flexDirection: 'column',
                flex: '1 1 auto',
                minHeight: 0,
                '& > div:first-child': {
                    display: 'flex',
                    overflow: 'hidden'
                }
            }
        }
    },
    dragMe: {
        cursor: 'move',
        color: 'white',
        width: 32,
        marginLeft: -32,
        opacity: 0.5,
        flex: '0 0 auto!important'
    },
    diagHeader: {
        color: 'white',
        background: palette.contentForeground[funeralHome],
        // borderRadius: '10px 10px 0 0',
        padding: '12px 44px',
        display: 'flex',
        alignItems: 'center',
        '& div': {
            flex: '1 1 auto'
        },
        position: 'sticky',
        zIndex: 2,
        top: 0
    },
    diagHeaderTitle: {
        color: '#FFFFFF',
        fontSize: '16px',
        fontWeight: 'lighter',
        lineHeight: 'normal'
    },
    diagHeaderSubtitle: {
        color: '#FFFFFF',
        fontSize: '36px',
        fontWeight: 'initial',
        lineHeight: 'normal'
    },
    diagHeaderIcon: {
        width: '70px',
        height: '70px',
        float: 'right',
        color: 'rgba(255,255,255,0.5)'
    },
    diagBody: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flex: '1 1 auto',
        minHeight: 'max(330px, 50vh)',
        width: 800,
        maxWidth: 'calc(100vw - 64px)',
        backgroundColor: '#fafafa',
        paddingTop: `${spacing(3)}!important`,
        [breakpoints.down('sm')]: {
            maxWidth: '100%'
        }
    },
    diagActions: {
        flex: '0 0 auto',
        justifyContent: 'space-between'
    },
    memberIcons: {
        display: 'flex',
        flexWrap: 'wrap',
        rowGap: spacing(1),
        columnGap: spacing(1)
    },
    saveButtonContainer: {
        position: 'static',
        minWidth: 'unset',
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        padding: spacing(2),
        paddingTop: 0,
        marginTop: spacing(-2),
        right: 0
    }
});

export default compose(withSnackbarMessage, withStyles(styles))(NewTransferModal);
